import React from 'react';
import {Link} from 'react-router';

import {Card, Text} from '@albert-io/atomic';

// legacy Mandark student shape — only the fields the card renders
export interface OverviewStudent {
  getId: () => string;
  getFullName: () => string;
  getAccuracyFromMeta: () => number;
  getMeta: () => {getCountOfGuesses: () => number};
}

interface StatRowProps {
  value: React.ReactNode;
  label: string;
}

// value left, label right — matching the legacy StudentColumns stat layout.
const StatRow = ({value, label}: StatRowProps) => (
  <div className='flex items-center justify-between gap-x2'>
    <Text size='s' bold color='tertiary'>
      {value}
    </Text>
    <Text size='s' bold color='tertiary'>
      {label}
    </Text>
  </div>
);

interface Props {
  student: OverviewStudent;
  classroomId: string;
}

export const StudentCard = ({student, classroomId}: Props) => (
  <Card
    as={Link}
    to={`/classes/${classroomId}/students/detail/${student.getId()}/overview`}
    border='none'
    paddingLevel={0}
    className='card-hover flex flex-col gap-x1 px-x2 py-x1 no-underline'
  >
    <Text className='content-primary underline font-semibold'>
      {student.getFullName()}
    </Text>
    <StatRow value={student.getMeta().getCountOfGuesses()} label='questions' />
    <div className='border-t border-dashed border-border-primary' />
    <StatRow value={`${student.getAccuracyFromMeta()}%`} label='raw accuracy' />
  </Card>
);
